export default interface IPropertyAttribute {
    id: string;
    name: string;
}

export class PropertyAttributeData implements IPropertyAttribute {
    id: string;
    name: string;

    constructor(id:string, name:string) {
        this.id = id;
        this.name = name;
    }
}